// Used to ensure all paths of a switch statement are covered
export const assertUnreachable = (value: never) => {
  throw new Error('This should be unreachable code');
};
